/**
 * Näherungsformeln swisstopo WGS84 ↔ LV95 (Genauigkeit rund 1 m),
 * «Näherungslösungen für die direkte Transformation CH1903+ ↔ WGS84».
 */
export function wgs84ToLv95(lat: number, lon: number): { e: number; n: number } {
  const phi = (lat * 3600 - 169028.66) / 10000;
  const lam = (lon * 3600 - 26782.5) / 10000;
  const e = 2600072.37 + 211455.93 * lam - 10938.51 * lam * phi - 0.36 * lam * phi * phi - 44.54 * lam ** 3;
  const n = 1200147.07 + 308807.95 * phi + 3745.25 * lam * lam + 76.63 * phi * phi - 194.56 * lam * lam * phi + 119.79 * phi ** 3;
  return { e, n };
}

export function lv95ToWgs84(e: number, n: number): { lat: number; lon: number } {
  const y = (e - 2600000) / 1e6;
  const x = (n - 1200000) / 1e6;
  const lam = 2.6779094 + 4.728982 * y + 0.791484 * y * x + 0.1306 * y * x * x - 0.0436 * y ** 3;
  const phi = 16.9023892 + 3.238272 * x - 0.270978 * y * y - 0.002528 * x * x - 0.0447 * y * y * x - 0.014 * x ** 3;
  return { lat: (phi * 100) / 36, lon: (lam * 100) / 36 };
}

/** Grobe Hülle der Schweiz inkl. Liechtenstein (für Dienstwahl, nicht für Grenzfragen). */
export function roughlyInSwitzerland(lat: number, lon: number): boolean {
  return lat >= 45.8 && lat <= 47.85 && lon >= 5.9 && lon <= 10.55;
}

export function isLv95(e: number, n: number): boolean {
  return e >= 2_480_000 && e <= 2_840_000 && n >= 1_070_000 && n <= 1_300_000;
}
